import { createSlice,  } from '@reduxjs/toolkit'

const initialState = {
  startTime: null,
};

const shareCertificateTimerSlice = createSlice({
    name: 'shareCertificateTimer',
    initialState,
    reducers: {
        setStartTime(state, action) {
            state.startTime = action.payload
        },
        resetTimer(state) {
            state.startTime = null
        },
    },
})

export const { setStartTime, resetTimer } = shareCertificateTimerSlice.actions
export const selectShareCertificateTimer = (state) => state.shareCertificateTimer?.startTime
export default shareCertificateTimerSlice.reducer
